import type { SymbolProps } from './types';

/**
 * The classic mark set.
 *
 * Every mark draws with `currentColor` so the theme controls colour through a
 * class, and each theme pack (roadmap Phase 6) can ship its own set of these
 * without touching the board components.
 */

export const XMark = ({ className = 'w-6 h-6' }: SymbolProps) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M18 6L6 18M6 6L18 18"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const OMark = ({ className = 'w-6 h-6' }: SymbolProps) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="3" fill="none" />
  </svg>
);

/** A faint dot, so an empty playable cell still reads as a target. */
export const EmptyMark = ({ className = 'w-6 h-6' }: SymbolProps) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="1" fill="currentColor" opacity="0.3" />
  </svg>
);

/** A dash, marking a mini-board that filled with no winner. */
export const DrawnMark = ({ className = 'w-6 h-6' }: SymbolProps) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M5 12H19" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);
